import { Injectable } from '@angular/core';
import { AnalyticsTrackingService } from './analytics-tracking-service';
import { CookieConsentService } from './cookie-consent-service';

@Injectable({ providedIn: 'root' })
export class AnalyticsLoaderService {
  private loaded = false;

  constructor(
    private cookieConsentService: CookieConsentService,
    private analyticsTrackingService: AnalyticsTrackingService,
  ) {}

  load(ga4MeasurementId: string): Promise<void> {
    if (this.loaded || globalThis.window === undefined) {
      return Promise.resolve();
    }

    return new Promise((resolve) => {
      globalThis.dataLayer ??= [];
      globalThis.gtag = function () {
        {
          // eslint-disable-next-line prefer-rest-params
          (globalThis.dataLayer ??= []).push(arguments);
        }
      };
      const gtag = globalThis.gtag;

      const script = document.createElement('script');
      script.async = true;
      script.src =
        'https://www.googletagmanager.com/gtag/js?id=' + ga4MeasurementId;

      script.addEventListener('load', () => {
        gtag('js', new Date());
        gtag('config', ga4MeasurementId, {
          send_page_view: false,
        });
        gtag('consent', 'default', {
          analytics_storage: this.cookieConsentService.hasAnalyticsConsent()
            ? 'granted'
            : 'denied',
          ad_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied',
        });
        this.loaded = true;
        resolve();
      });

      document.head.append(script);
    });
  }
  setAnalyticsConsent(consent: boolean) {
    if (!globalThis.gtag) return;

    globalThis.gtag('consent', 'update', {
      analytics_storage: consent ? 'granted' : 'denied',
    });
    if (consent) {
      this.analyticsTrackingService.pageView(globalThis.location.pathname);
    }
  }
}
